export const SITE_DATA = 'SITE_DATA';
export const CONFIG = 'CONFIG';
export const APP_LOADING = 'APP_LOADING';
export const APP_SHARE = 'APP_SHARE';
export const QR_DOWNLOAD = 'QR_DOWNLOAD';
export const QR_HEADER_DOWNLOAD = 'QR_HEADER_DOWNLOAD';
export const PRIMARY_ACTION = 'PRIMARY_ACTION';
export const ALL_REVIEWS = 'ALL_REVIEWS';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_REVIEW_RECOMMENDATIONS = 'UPDATE_REVIEW_RECOMMENDATIONS';